export default {
    title: '我的作业',
    hero: {
        bgAlt: '游乐园背景',
        panelAlt: '我的作业标题面板',
        title: '我的作业',
        description: '查看老师布置的作业，<br/>一步一步认真完成吧。',
    },
    aria: {
        boardLabel: '作业看板',
        tabsLabel: '作业状态标签',
        progress: '作业进度 {percent}%',
        actionButton: '{title} {label}',
    },
    tabs: {
        active: '进行中的作业',
        ended: '已截止的作业',
    },
    meta: {
        activityCount: '活动数',
        createdAt: '创建日期',
        endedAt: '结束日期',
    },
    status: {
        before: '未开始',
        inprogress: '进行中',
        complete: '已完成',
        endedComplete: '已完成',
        endedIncomplete: '未完成',
    },
    actions: {
        view: '查看作业',
        studyComplete: '学习完成',
        viewResult: '查看结果',
    },
    stamp: {
        alt: '完成印章',
    },
    empty: {
        active: '没有进行中的作业。',
        ended: '没有已截止的作业。',
    },
    activity: {
        name: '活动 {index}',
    },
    modal: {
        closeAria: '关闭弹窗',
        close: '关闭',
        start: '开始',
    },
    flash: {
        title: {
            info: '提示',
            warning: '注意',
            error: '错误',
        },
        confirm: '确定',
    },
};
